import { combineReducers } from "redux";
import collapsibles from "./componentStatus/collapsibles";
import hasChangedFilters from "./componentStatus/hasChangedFilters";
import phonePicker from "./componentStatus/phonePicker";
import phoneSearch from "./componentStatus/phoneSearch";
import offerResultsPagination from "./componentStatus/offerResultsPagination";
import sliders from "./componentStatus/sliders";

const componentStatus = combineReducers({
  collapsibles,
  hasChangedFilters,
  phonePicker,
  phoneSearch,
  offerResultsPagination,
  sliders
});

export default componentStatus;
